<script>
import DataTableDateColumnVue from './DataTableDateColumn.vue';

export default {
  name: 'DataTableHoursTable',
  extends: DataTableDateColumnVue,
  computed: {
    data() {
      return this.date(this.value, 'HH:mm:ss').format('HH:mm:ss');
    },
  },
};
</script>
